module.exports = __webpack_public_path__ + "img/original-sketch-1.7231802c.png";